module.exports = __webpack_public_path__ + "img/w3_check_circle_grey.5705f462.png";